import React, { useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";
import "./App.css";
import Header from "./components/Header/Header";
import Corner from "./pages/Hustle/Corner";
import Home from "./pages/Home";
import Consignment from "./pages/Hustle/Consignment";
import SafeHouse from "./pages/SafeHouse";
import TermsPage from "./pages/Terms";
import PrivacyPage from "./pages/Privacy";
import LeaderBoard from "./pages/LeaderBoard";
//import Mission from "./pages/Mission";
import Challenge from "./pages/Challenge";
import Stash from "./pages/Stash";
import Laundering from "./components/Laundering/laundering";
import PackShop from "./components/Store/PackShop";
import BoostShop from "./components/Store/BoostShop";
//import WuffShop from "./components/Store/WuffShop"
import MarketNefty from "./components/Store/MarketNefty"
import DropsNefty from "./components/Store/DropsNefty"
//import MerchShop from "./components/Store/merchshop";
import Transfers from "./components/Transfers/transfers";
import Traphouse from "./components/Hustle/Traphouse/Traphouse";
import Clandestine from "./components/Hustle/Clandestine/Clandestine";
//import Raid from "./pages/Hustle/Raid";
import Character from "./components/GangWars/Character/Character";
import Tournaments from "./components/GangWars/Tournaments/Tournaments";

import { ReactComponent as ScrollUpSVG } from "assets/images/icons/scrollup.svg";
import Profile from "pages/Profile";
import Gambling from "pages/Gambling";
import WalletContext from "context";
import DropZone from "components/Dropzone/dropzone";
import PVP from "components/GangWars/PvP/PVP";
import NPC from "components/GangWars/NPC/NPC";

const App = ({ ual }) => {
  const [balance, setBalance] = useState({
    cleanCash: 0,
    slot: 0,
    final: 0,
    dirty: 0,
  });

  return (
    <div>
      <div className="App font-[Montserrat]">
        <WalletContext.Provider value={{ balance, setBalance }}>
          <BrowserRouter>
            <Header ual={ual}/>
            <div className="h-20"></div>
            <ScrollToTop smooth component={<ScrollUpSVG />} />
            <div className="md:pt-20 bg-[#131312]">
              <Routes>
                {/* Profile, G Rank, Safe , Leader board  */}
                <Route path="/character" element={<Character ual={ual} />} />
                <Route path="/pvp" element={<PVP ual={ual} />} />
                <Route path="/tournaments" element={<Tournaments ual={ual} />} />
                <Route path="/npc" element={<NPC ual={ual} />} />

                <Route path="/" element={<Home ual={ual}/>} />
                <Route path="/profile" element={<Profile ual={ual} />} />
                <Route path="/play" element={<Gambling ual={ual} />} />
                
                <Route path="/consignment" element={<Consignment ual={ual} />} />
                <Route path="/the-corner" element={<Corner ual={ual} />} />
                <Route path="/the-traphouse" element={<Traphouse ual={ual} />} />
                <Route path="/clandestine-lab" element={<Clandestine ual={ual} />} />
                
                <Route path="/laundering" element={<Laundering ual={ual} />} />
                <Route path="/pack-shop" element={<PackShop ual={ual} />} />
                <Route path="/booster-shop" element={<BoostShop ual={ual} />} />
                {/* <Route path="/wuffy" element={<WuffShop ual={ual} />} /> */}
                
                <Route path="/market" element={<MarketNefty ual={ual} />} />
                <Route path="/drops" element={<DropsNefty ual={ual} />} />
                
                <Route path="/transfers" element={<Transfers ual={ual} />} />
                <Route path="/stash" element={<Stash ual={ual} />} />
                <Route path="/safe" element={<SafeHouse ual={ual} />} />

                <Route path="/terms" element={<TermsPage ual={ual} />} />
                <Route path="/privacy" element={<PrivacyPage ual={ual} />} />
               
                <Route path="/leaderboard" element={<LeaderBoard ual={ual} />} />
                {/* <Route path="/mission" element={<Mission ual={ual} />} /> */}
                <Route path="/challenge" element={<Challenge ual={ual} />} />
                <Route path="/dropzone" element={<DropZone ual={ual} />} />
              </Routes>
            </div>
          </BrowserRouter>
        </WalletContext.Provider>
      </div>
    </div>
  );
};

export default App;
